import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { BixiTimeComponent } from './time.component';

const COMPONENTS = [BixiTimeComponent];

@NgModule({
  imports: [CommonModule, NzToolTipModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS]
})
export class BixiTimeModule {
}
